import underscorize from './underscorize'

export const isBlank = (str) => !str || str.trim().length == 0
export const isPresent = (str) => !isBlank(str)
export const isValidNumber = (num) => num != null && (typeof num != "undefined") && !isNaN(parseFloat(num))

export const fieldError = (modelName) => (field, error) => {
  // we dont want to show the field name in error messages
  // const fieldT = I18n.t(prefix + "." + underscorize(field))
  const errorT = translateError(underscorize(modelName), underscorize(field), underscorize(error))
  return `${errorT}`
}

// # http://guides.rubyonrails.org/i18n.html#error-message-scopes
const scopes = (modelName, attributeName) =>
  [
    `activerecord.errors.models.${modelName}.attributes.${attributeName}`,
    `activerecord.errors.models.${modelName}`,
    "activerecord.errors.messages",
    `errors.attributes.${attributeName}`,
    "errors.messages"
  ]


export const translateError = (model, attribute, error) => {
  const defaults = scopes(model, attribute).map( (s) => ({ scope: `${s}.${error}` }))
  return I18n.t(error, { defaults })
}

export const areArraysEqual = (arr1, arr2) =>  JSON.stringify(arr1) === JSON.stringify(arr2) 
